<template>
    <float-bottom class="c-jhs-free-lp-btn-float-bottom">
        <div @click="isActive ? startAudition() : ''" class="c-jhs-free-lp-btn-float-bottom-btn" data-jest="apply-link">
            <img :src="buildImgUrl(isActive ? 'btn_apply.png' : 'btn_apply_disabled.png')" alt="今すぐ申し込む">
        </div>
    </float-bottom>
</template>

<script>
import FloatBottom from "../atoms/FloatBottom.vue";
import {getClickAllEvent} from "../../util/Ga4EventUtil";
import {mapGetters} from "vuex";
import * as urlUtil from "../../util/UrlUtil";

export default {
    name: "JhsFreeLpBtnFloatBottom",
    components: {FloatBottom},
    props: {
        isActive: {
            type: Boolean,
            required: true
        }
    },
    emits: ['clicked'],
    computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus'
        }),
        /*
         * ログイン/未ログインによって遷移先を変える
         */
        applyBtnUrl() {
            if(this.accountStatus.membership.isGuest) {
                return '/guidance/login';
            } else {
                return '/input/profile';
            }
        }
    },
    methods: {
        transitionPage(nextUrl) {
            location.href = nextUrl
        },
        /*
          * VOYAGERFRONT-6111 LINEイベントコード設置
          * ユニテのため切り出している
          */
        sendLineTag() {
            _lt('send', 'cv', {
                type: 'event1'
            },['00959236-1b74-4654-8bc6-3b291d37ee67']);
        },
        /*
         * GA4イベントを送信し次のページへ遷移させる
         */
        startAudition() {
            this.emitClicked()
            const nextUrl = location.pathname + location.search + '#' + this.applyBtnUrl;
            // ボタンテキストが打ち文字でなく画像なのでBtnコンポーネントにtextを渡せないため
            // こちらでclick_allを送信し次のページへ遷移させる
            getClickAllEvent(nextUrl, '今すぐ申し込む')

            // 広告タグ送信
            this.sendLineTag();

            // this.$router.pushで遷移させると現状mountedで設定したscrollイベントが次のページでも走ってしまう
            // 適切にEventListenerをremoveする処理が思いつかないので
            // 応急処置としてlocation.hrefで遷移させページ更新させている
            this.transitionPage(nextUrl);
        },
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/lp/' + imgName)
        },
        // メソッドに切り出さなくても実現できるが、テストのためメソッドとして定義している
        emitClicked() {
            this.$emit('clicked')
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:math";

// ベースとなるデバイス幅
@use "../../../scss/v2/base/variables";
$grid-device-width: 375px;
// 余白
$grid-base: percentage(math.div(16px, $grid-device-width)); // 16px
$grid-consistent: $grid-base * 0.5; // 8px
.c-jhs-free-lp-btn-float-bottom {
    padding: $grid-consistent;
    &-btn {
        display: block;
        img {
            height: 100%;
        }
    }
    :deep(.c-float-bottom-background) {
        padding: 0 $grid-base;
        border-top: none;
        background: variables.$color-white;
        box-shadow: 0 -2px 8px 0 rgba(variables.$color-jhs-free-shadow-brown, variables.$opacity-50);
        margin: 0 (-$grid-consistent);
    }
}
</style>
